/** @format */

import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HomefieldButtonModule } from '@homefield';
import { MatExpansionModule } from '@angular/material/expansion';
import { HtmlSanitizerPipe } from '@shared/utils/pipes';
import { AutoATagDirective } from '@shared/utils/directives';
import { AccordionComponent } from './accordion.component';

@NgModule({
	imports: [
		AutoATagDirective,
		CommonModule,
		HomefieldButtonModule,
		HtmlSanitizerPipe,
		MatExpansionModule
	],
	declarations: [AccordionComponent],
	providers: [],
	exports: [AccordionComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AccordionModule {}
